import { Badge } from '../../r2/Badge';
import { Text } from '../../r2/Text';
import styles from './DiffEntry.module.css';

export interface DiffEntryProps {
  changeType: 'added' | 'modified' | 'removed';
  crdId: string;
  description: string;
  composes?: string[];
  index: number;
}

const TYPE_VARIANT: Record<string, 'success' | 'warning' | 'danger'> = {
  added: 'success',
  modified: 'warning',
  removed: 'danger',
};

const TYPE_LABEL: Record<string, string> = {
  added: 'Added',
  modified: 'Modified',
  removed: 'Removed',
};

export function DiffEntry({
  changeType,
  crdId,
  description,
  composes = [],
  index,
}: DiffEntryProps) {
  return (
    <div
      data-crd-id="r3.bq-diff-entry"
      data-crd-layer="r3"
      className={styles.entry}
      style={{ animationDelay: `${index * 150}ms` }}
    >
      <div className={styles.header}>
        <Badge variant={TYPE_VARIANT[changeType]}>
          {TYPE_LABEL[changeType]}
        </Badge>
        <code className={styles.crdId}>{crdId}</code>
      </div>
      <Text size="r3" color="n500">
        {description}
      </Text>
      {composes.length > 0 && (
        <div className={styles.composes}>
          <Text size="r4" color="n400" as="span">
            composes:
          </Text>
          {composes.map((c) => (
            <code key={c} className={styles.dep}>
              {c}
            </code>
          ))}
        </div>
      )}
    </div>
  );
}
